const collection = {
  slug: "comme-des-garcons-1997ss-body-meets-dress-guide",
  metaTitle:
    "コムデギャルソン名作『こぶドレス』とは｜1997SS Body Meets Dressと買取ガイド",
  metaDescription:
    "COMME des GARÇONS 1997SS『Body Meets Dress, Dress Meets Body』、通称こぶドレスを解説。身体に不自然な膨らみを加え、服が身体を美しく補正するという常識を逆転させた川久保玲の最重要コレクション。コムデギャルソン名作、アーカイブ価値、買取相談までEnclopediaが詳しく案内します。",
  metaKeywords:
    "コムデギャルソン 名作,コムデギャルソン こぶドレス,COMME des GARCONS 1997SS,Body Meets Dress Dress Meets Body,ボディミーツドレス,川久保玲 名作,コムデギャルソン アーカイブ,COMME des GARCONS アーカイブ,コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,川久保玲 コレクション,コムデギャルソン 代表作,コムデギャルソン レディース 買取,コムデギャルソン 古着 買取,Enclopedia,アンクロペディア",
  canonicalPath:
    "/archive_collection/comme-des-garcons-1997ss-body-meets-dress-guide",
  heroImage: "media/archive_fashion/archive_guide1.png",
  heroImageAlt:
    "COMME des GARÇONS 1997SS Body Meets Dress Dress Meets Body こぶドレスを解説するEnclopediaアーカイブガイド画像",
  heroNumber: "08 / BODY MEETS DRESS",
  label: "ARCHIVE COLLECTION STUDY",
  title: "COMME des GARÇONS 1997SS『Body Meets Dress, Dress Meets Body』",
  lead: "COMME des GARÇONS 1997SS『Body Meets Dress, Dress Meets Body』。\n通称「こぶドレス」。\n\n身体に不自然な膨らみを加え、服が身体を美しく補正するという常識を逆転させた、川久保玲の最重要コレクションの一つです。\n\n服が身体を飾るのではなく、身体の輪郭そのものを作り替える。\nこのコレクションを理解すると、なぜコムデギャルソンが単なるブランドではなく、服の見方を変えた存在として語られるのかが見えてきます。",
  keywordLine: [
    "body meets dress",
    "lumps and bumps",
    "rei kawakubo",
    "buyback guide",
  ],
  thesis:
    "『Body Meets Dress, Dress Meets Body』の重要性は、服が身体を美しく整えるという前提を壊し、服そのものが身体の輪郭を作り替える装置になった点にあります。",
  whyTitle: "なぜ『こぶドレス』は、コムデギャルソンを語る上で外せないのか。",
  whyBody:
    "一般的な服は、身体を美しく見せるために作られます。\n細く見せる。脚を長く見せる。胸や腰のラインを整える。\nつまり服は、身体を“理想”に近づけるための道具として扱われてきました。\n\nしかし、COMME des GARÇONS 1997SSはその前提を反転させます。\n身体の脇、腰、背中、腹部に不自然な膨らみを加え、見る人が慣れ親しんだ美しいシルエットをあえて崩す。\nその結果、服は身体を補正するものではなく、身体そのものの見え方を作り替える存在になります。\n\nこのコレクションが今も名作として語られるのは、奇抜だったからではありません。\n“美しい身体とは何か”“服は身体に何をするのか”という問いを、ランウェイ上で直接提示したからです。\nEnclopediaでは、このような文脈を入口に、コムデギャルソンのアーカイブ価値を読み取り、買取やレンタルを通じて次のユーザーへつなげます。",
  pillars: [
    {
      number: "01",
      title: "BODY AS QUESTION",
      text: "1997SSのこぶドレスは、身体を美しく見せるのではなく、身体とは何かを問い直す服です。膨らみは欠点ではなく、身体の新しい輪郭として提示されます。",
    },
    {
      number: "02",
      title: "DRESS AS STRUCTURE",
      text: "服は身体を覆う布ではなく、身体そのものを構築する装置になります。ドレスと身体の境界が曖昧になることが、このコレクションの核心です。",
    },
    {
      number: "03",
      title: "ARCHIVE AS VALUE",
      text: "COMME des GARÇONSの名作は、古い服だから価値があるのではありません。時間が経っても問いが残り、今も読み直せるからアーカイブとして評価されます。",
    },
  ],
  readingTitle:
    "身体、膨らみ、違和感から読む『Body Meets Dress, Dress Meets Body』。",
  readingIntro:
    "このコレクションは、ただ形が変わっているから有名なのではありません。どこに膨らみが置かれ、なぜ身体の輪郭が崩され、なぜそれが美しさの問いになるのかを見ることで、コムデギャルソンの深度が見えてきます。",
  observations: [
    {
      index: "01",
      title: "膨らみは欠点ではなく、身体を作り替える構造だった",
      text: "こぶドレスで最も印象的なのは、身体の自然なラインから外れた場所に置かれた膨らみです。\n腰、背中、腹部、肩まわり。\n一般的な服なら隠したり補正したりする部分に、あえてボリュームを加える。\n\nそれによって、身体は“きれいに見せる対象”ではなく、“作り替えられる対象”になります。\n服が身体に従うのではなく、服が身体の輪郭を新しく作る。\nこの反転が、1997SSの強さです。",
    },
    {
      index: "02",
      title: "ギンガムチェックが、違和感をさらに強くした",
      text: "1997SSでは、ギンガムチェックのような日常的で親しみやすい柄が使われました。\nここが重要です。\nもしすべてが黒く、抽象的で、彫刻的な服だったなら、作品はもっと遠いものに見えたかもしれません。\n\nしかし、どこか可愛く、日常的で、親しみのある布に、不自然な膨らみが入る。\nそのズレによって、見る人は“可愛いのか、怖いのか、美しいのか、変なのか”を簡単に判断できなくなります。\nコムデギャルソンらしい違和感は、この距離感から生まれています。",
    },
    {
      index: "03",
      title: "美しい身体を作る服ではなく、美しさの基準を壊す服",
      text: "多くのファッションは、身体を理想に近づけます。\n細く、長く、整って、バランスよく。\n\nしかし川久保玲は、その理想そのものを疑います。\nなぜ服は身体を整えなければならないのか。\nなぜ膨らみは隠されるべきなのか。\nなぜ女性の身体は、決められた美しさに沿わなければならないのか。\n\nこぶドレスは、答えを出す服ではありません。\n見る人にその問いを突きつける服です。",
    },
    {
      index: "04",
      title: "“Body Meets Dress”というタイトルが示すもの",
      text: "『Body Meets Dress, Dress Meets Body』というタイトルは、非常に重要です。\n身体がドレスに出会い、ドレスが身体に出会う。\nつまり、身体が先にあって服がそれに合わせるのでも、服が先にあって身体を押し込めるのでもありません。\n\n身体と服が互いに影響し合い、どちらがどちらを形作っているのか分からなくなる。\nこの相互関係こそ、コレクション全体のテーマです。\n服と身体の境界が曖昧になることで、ファッションは単なる装飾から、身体を考えるメディアへ変わります。",
    },
    {
      index: "05",
      title: "なぜ“名作”として残り続けるのか",
      text: "1997SSが名作として残る理由は、話題性だけではありません。\n身体、女性性、美しさ、服の役割という普遍的なテーマに触れているからです。\n\n流行のシルエットは変わります。\n細身が流行る時代もあれば、オーバーサイズが流行る時代もあります。\nしかし“服は身体をどう見せるのか”という問いは、どの時代にも残ります。\n\nだからこそ、Body Meets Dressは過去のコレクションでありながら、今も現代的に見えるのです。",
    },
    {
      index: "06",
      title: "買取で見るべきなのは、古さではなく文脈",
      text: "コムデギャルソンの買取では、単に古い服だから価値がある、という見方では不十分です。\nどのシーズンか。どのラインか。どんなテーマと接続しているか。どれだけブランド史の中で重要か。\n\n1997SSのような象徴的コレクションは、まさに文脈が価値になる代表例です。\nEnclopediaでは、コムデギャルソンの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
    },
  ],
  quote:
    "こぶドレスは、身体を美しく見せる服ではない。身体の美しさを決めている基準そのものを揺さぶる服です。",
  perspectiveTitle:
    "Enclopediaは、コムデギャルソンを“古着”ではなく“問いが残るアーカイブ”として見る。",
  perspectiveCards: [
    {
      number: "01",
      title: "KNOWLEDGE",
      text: "1997SS『Body Meets Dress, Dress Meets Body』を、身体、膨らみ、美しさの基準、川久保玲の思想から読み解きます。",
    },
    {
      number: "02",
      title: "SERVICE ENTRY",
      text: "この記事は、コムデギャルソンの名作を知る入口であると同時に、Enclopediaが服をどのように読み、扱い、次へつなげるサービスなのかを知ってもらう入口です。",
    },
    {
      number: "03",
      title: "BUYBACK",
      text: "買取対象は1997SSだけに限定しません。COMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全般を文脈込みで相談対象として見ます。",
    },
  ],
  experienceTitle:
    "コムデギャルソンを売る前に、その一着がどの文脈にあるかを確認する。",
  experienceBody:
    "コムデギャルソンの買取では、ブランド名だけでなく、ライン、年代、シーズン、デザイナー、素材、状態、現在の需要が重要です。\n今回の記事では1997SS『Body Meets Dress, Dress Meets Body』を中心に解説していますが、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、COMME des GARÇONS HOMME PLUS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiya、tao COMME des GARÇONSなど、コムデギャルソン全般を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n名作コレクションを知ることは、自分の持っている一着の価値を見直す入口になります。",
  experienceItems: [
    "COMME des GARÇONSのライン名を確認する",
    "タグ・品質表示・年代・シーズンが分かる写真を撮影する",
    "HOMME PLUS、JUNYA、noirなどラインごとの特徴を確認する",
    "1997SSなど名作シーズンに近い文脈があるか確認する",
    "状態・サイズ・付属品・購入時期を確認する",
    "シーズンや価値が分からない場合もLINEで写真を送る",
  ],
  archiveItemsTitle: "コムデギャルソンの名作を入口に、買取相談へつなげる。",
  archiveItemsBody:
    "Enclopediaでは、コムデギャルソンを単なるブランド古着としてではなく、コレクション背景、ライン、年代、思想、現在の需要まで含めて見ています。この記事で1997SSの重要性に触れた方は、所有しているコムデギャルソンの一着も、まずはLINEでご相談ください。",
  archiveItems: [
    {
      label: "BUYBACK FOCUS 01",
      title: "コムデギャルソン買取ページへ",
      productPath: "/brand_buyback/comme-des-garcons",
      productImage: "",
      text: "COMME des GARÇONS、HOMME PLUS、HOMME、JUNYA WATANABE、noir kei ninomiyaまで。コムデギャルソン全般の買取対象と査定視点を確認できます。",
    },
    {
      label: "BUYBACK FOCUS 02",
      title: "LINEでコムデギャルソンを事前査定",
      productPath: "https://line.me/R/ti/p/@240yzqkh",
      productImage: "",
      text: "タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。シーズンが分からない場合も相談可能です。",
    },
    {
      label: "SERVICE FOCUS 03",
      title: "Enclopediaのアーカイブレンタルを見る",
      productPath: "/",
      productImage: "",
      text: "Enclopediaは買取だけでなく、アーカイブを次の人が体験できるレンタルサービスです。服を所有物ではなく、文化として循環させます。",
    },
  ],
  finalCta: {
    title:
      "こぶドレスの記事を読んだら、次はEnclopediaでコムデギャルソンの価値を相談する。",
    body: "COMME des GARÇONS 1997SS『Body Meets Dress, Dress Meets Body』は、コムデギャルソンの名作を知るための強い入口です。\nただし、Enclopediaが見ているのはこのシーズンだけではありません。\nCOMME des GARÇONS、HOMME PLUS、JUNYA WATANABE、noir kei ninomiyaまで、コムデギャルソン全般の価値をアーカイブの視点で確認します。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
    buttonLabel: "コムデギャルソンをLINEで事前査定する",
    buttonHref: "https://line.me/R/ti/p/@240yzqkh",
  },
};

export default collection;
